import React from "react";
import useQuotationSearch from "./useQuotationSearch";
import Control from "../../../common/Control";
import GroupSelector from "../../../common/GroupSelector";
import styles from "../QuotationList.module.scss";

const QuotationSearch = ({ handlePageParamsChange }) => {
  const { quotationSearch, actions } = useQuotationSearch({
    handlePageParamsChange,
  });

  return (
    <form onSubmit={actions.onSubmit} className={styles.searchCard}>
      <div className={styles.searchGroups}>
        <GroupSelector
          label="Rechercher dans les groupes"
          name="userGroups"
          change={actions.onChangeSearch}
          value={quotationSearch.userGroups}
        />
      </div>

      <div className={styles.searchFields}>
        <Control
          label="Client"
          name="clientName"
          change={actions.onChangeSearch}
          value={quotationSearch.clientName}
        />
        <Control
          label="Référence"
          name="reference"
          change={actions.onChangeSearch}
          value={quotationSearch.reference}
        />
        <Control
          label="Marque"
          name="brand"
          change={actions.onChangeSearch}
          value={quotationSearch.brand}
        />
        <Control
          label="Modèle"
          name="brandModel"
          change={actions.onChangeSearch}
          value={quotationSearch.brandModel}
        />
        <Control
          label="Immatriculation"
          name="immatriculation"
          change={actions.onChangeSearch}
          value={quotationSearch.immatriculation}
        />
        <div className={styles.searchActions}>
          <button
            className={styles.roundBtn}
            onClick={actions.onResetSearch}
            type="button"
            title="Réinitialiser la recherche"
          >
            <i className="fa fa-times" />
          </button>
          <button
            className={styles.roundBtnPrimary}
            type="submit"
            title="Rechercher"
          >
            <i className="fa fa-search" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default QuotationSearch;
